import moment from 'moment-timezone';
import { TranslateService } from '@ngx-translate/core';


export class DateUtils {

  public static timestampAsHumanReadable(timestamp: number): string {
    return new Date(timestamp * 1000).toISOString();
  }

  public static timestampAsDate(timestamp: number): Date {
    return new Date(timestamp * 1000);
  }

  /** ex. "2024-04-26_10-49-31_043" */
  public static dateToHorodatage(dateRef: Date = null): string {
    const digit2 = function(a) { return (a < 10 ? '0' : '')+a; }
    const digit3 = function(a) { return (a < 100 ? '0' : '')+(a < 10 ? '0' : '')+a; }

    const date = dateRef == null ? new Date() : dateRef;
    return `${date.getFullYear()}-${digit2(date.getMonth() + 1)}-${digit2(date.getDate())}_${digit2(date.getHours())}-${digit2(date.getMinutes())}-${digit2(date.getSeconds())}_${digit3(date.getMilliseconds())}`;
  }

  public static dateToDateString(dateRef: Date = null): string {
    const digit2 = function(a) { return (a < 10 ? '0' : '')+a; }
    //const digit3 = function(a) { return (a < 100 ? '0' : '')+(a < 10 ? '0' : '')+a; }

    const date = dateRef == null ? new Date() : dateRef;
    return `${date.getFullYear()}-${digit2(date.getMonth() + 1)}-${digit2(date.getDate())}`;
  }

  public static parseDate(sDateTimeTz: string): Date {
    let res: Date = null
    if (!!sDateTimeTz && sDateTimeTz.length>0) {
      try {
        res = new Date(Date.parse(sDateTimeTz));
      }
      catch ( e ) {
        console.error('Erreur lors du parse de la date : '+sDateTimeTz, e);
      }
    }
    return res;
  }

    public static toDateTimeTzString(num: number): string {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = moment(new Date(num)).tz(timezone);
        return date.toISOString();
    }

    // retourne un objet permettant d'avoir la durée entre 2 dates
    public static diffDates(start: Date, end: Date) {
        const years = end.getFullYear() - start.getFullYear();
        const months = end.getMonth() - start.getMonth();
        const days = end.getDate() - start.getDate();
        const hours = end.getHours() - start.getHours();
        const minutes = end.getMinutes() - start.getMinutes();
        const seconds = end.getSeconds() - start.getSeconds();

        return { years, months, days, hours, minutes, seconds };
    }


    // retourne un objet affichant la durée entre 2 dates
    public static diffDatesToString(start: Date, end: Date, translateService : TranslateService, withHours = false, withMinutes = false, withSeconds = false) : string {
        let displayDiff = ''
        const diff = DateUtils.diffDates(start, end);
        if (diff.years>0) {
            displayDiff = translateService.instant('DURATION.MoreThanAYear');
        } else
            {
                if (diff.months>0) {
                    displayDiff += diff.months + ' ' ;
                    if (diff.months===1) {
                        displayDiff +=translateService.instant( 'DURATION.month' );
                    } else {
                        displayDiff +=translateService.instant( 'DURATION.months' );
                    }
                }
                if (diff.days>0) {
                    if (diff.months>0) {
                        displayDiff += ' ';
                    }

                    displayDiff += diff.days + ' ';
                    if (diff.days===1) {
                        displayDiff += translateService.instant('DURATION.day');
                    } else {
                        displayDiff += translateService.instant('DURATION.days');
                    }

                    if (withHours) {
                        displayDiff +=     ' '  + diff.hours  + ' ';
                        if(diff.hours===1) {
                            displayDiff += translateService.instant('DURATION.hour');
                        } else {
                            displayDiff += translateService.instant('DURATION.hours');
                        }

                    }
                    if (withMinutes) {
                        displayDiff +=     ' '  + diff.minutes  + ' ';
                        if(diff.minutes===1) {
                            displayDiff += translateService.instant('DURATION.minute');
                        } else {
                            displayDiff += translateService.instant('DURATION.minutes');
                        }

                    }
                    if (withSeconds) {
                        displayDiff +=     ' '  + diff.seconds  + ' ';
                        if(diff.seconds===1) {
                            displayDiff += translateService.instant('DURATION.second');
                        } else {
                            displayDiff += translateService.instant('DURATION.seconds');
                        }

                    }
                } else {
                    if (withHours) {
                        displayDiff +=     ' '  + diff.hours  + ' ';
                        if(diff.hours===1) {
                            displayDiff += translateService.instant('DURATION.hour');
                        } else {
                            displayDiff += translateService.instant('DURATION.hours');
                        }

                    }
                    if (withMinutes) {
                        displayDiff +=     ' '  + diff.minutes  + ' ';
                        if(diff.minutes===1) {
                            displayDiff += translateService.instant('DURATION.minute');
                        } else {
                            displayDiff += translateService.instant('DURATION.minutes');
                        }

                    }
                    if (withSeconds) {
                        displayDiff +=     ' '  + diff.seconds  + ' ';
                        if(diff.seconds===1) {
                            displayDiff += translateService.instant('DURATION.second');
                        } else {
                            displayDiff += translateService.instant('DURATION.seconds');
                        }

                    }
                    if(!withHours && !withMinutes && !withSeconds) {
                        displayDiff +=translateService.instant( 'DURATION.LessThanADay' );
                    }
                }
            }
        return displayDiff;
    }

    // test si la chaine de caractère est du format YYYY-MM-DD
    public static isStringDateFormatYYYYMMDD (value: string): boolean
    {
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        return regex.test(value);
    }
}
